import BarSection from './BarSection';
import classNames from 'classnames';
import Layout from './Layout';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styles from './css/Bar.scss';

export default class Bar extends Component {
    static propTypes = {
        children: PropTypes.node,
        className: PropTypes.string,
    }

    render() {
        const { className, children, ...props } = this.props;
        const classes = classNames(styles.bar, className);

        return (
            <div className={classes} {...props}>
                <Layout type='columns'>
                    {children}
                </Layout>
            </div>
        );
    }
}

Bar.Section = BarSection;
